export class SystemUserToken {
  static ISystemUserRepository = Symbol("ISystemUserRepository");
  static SystemUserUseCase = Symbol("SystemUserUseCase");
  static SystemUserViewModel = Symbol("SystemUserViewModel");
}

